module.exports = __webpack_public_path__ + "static/media/aspen-media-logo@2x.5d55b141.jpg";